<h1 class="py-6 text-lg text-base-gray-500" translate>geral.forma-avaliacao</h1>

<ng-container *ngIf="scales$ | async as data; else emptyTemplate">
  <form [formGroup]="form" class="pb-6">
    <app-form-field *ngIf="showField(data.types)">
      <label app-label translate>geral.tipo</label>
      <ng-select
        app-select
        [placeholder]="'geral.tipo' | translate"
        [clearable]="false"
        [searchable]="false"
        formControlName="type"
        (change)="onReset()"
      >
        <ng-option [value]="type" *ngFor="let type of data.types">{{ labelType(type) | translate }}</ng-option>
      </ng-select>
    </app-form-field>

    <!-- Score -->
    <app-form-field class="w-full" *ngIf="isEqual(form.value.type, evaluation.Score)">
      <label app-label translate>eclass.nota</label>
      <input
        app-input
        currencyMask
        [options]="scoreConfig"
        type="text"
        formControlName="score"
        [placeholder]="'eclass.informe-nota' | translate"
      />
    </app-form-field>

    <!-- Scale -->
    <app-form-field class="w-full" *ngIf="isEqual(form.value.type, evaluation.Scale)">
      <label app-label translate>geral.escala</label>
      <ng-select
        app-select
        [items]="data.scales"
        [clearable]="false"
        [searchable]="false"
        bindValue="escala_id"
        bindLabel="sigla"
        formControlName="score"
        [placeholder]="'eclass.selecione' | translate"
      >
        <ng-template ng-option-tmp let-scale="item" let-index="index" let-search="searchTerm">
          <div>
            <p [ngOptionHighlight]="search" class="text-base font-semibold">{{ scale.sigla }}</p>
            <p class="text-sm text-base-whisper-900">
              {{ scale.descricao }}
            </p>
            <p *ngFor="let item of scale?.items" class="ml-2">- {{ item.sigla }} ({{ item.descricao }})</p>
          </div>
        </ng-template>
      </ng-select>
    </app-form-field>
  </form>
</ng-container>
<ng-template #emptyTemplate>
  <div>
    <app-jumbotron class="mt-14" translate> eclass.selecione-disciplina-turma </app-jumbotron>
  </div>
</ng-template>
